module.exports = __webpack_public_path__ + "res/33-img_i_value.a80c8b1201fc8a0ff95064c8c87e7ee7.png";